import React from 'react';

export const TwitterSvg = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-680, -20)" fillRule="nonzero">
        <g transform="translate(680, 20)">
          <circle fill="#20A8D4" cx="20" cy="20" r="20"></circle>
          <path
            d="M26.22,10.25 L29.528,10.25 L22.301,18.51 L30.803,29.75 L24.146,29.75 L18.932,22.933 L12.966,29.75 L9.656,29.75 L17.386,20.915 L9.23,10.25 L16.056,10.25 L20.769,16.481 L26.22,10.25 Z M25.059,27.77 L26.892,27.77 L15.06,12.126 L13.093,12.126 L25.059,27.77 Z"
            fill="#FFFFFF"
          />
        </g>
      </g>
    </g>
  </svg>
);
